(() => {
  'use strict';
  const root = document.querySelector('#rd-brand-landing');
  if (!root) return;
  const guidance = root.querySelector('[data-device-guidance]');
  if (guidance) {
    guidance.querySelectorAll('select[onchange]').forEach(select => {
      select.removeAttribute('onchange');
      select.addEventListener('change', () => {
        const url = select.value;
        if (url.startsWith('/collections/') || url.startsWith('/products/')) location.assign(url);
      });
    });
  }
  const form = root.querySelector('[data-device-form]');
  if (!form) return;
  const query = form.elements.query, brand = form.elements.brand, sort = form.elements.sort;
  const cards = root.querySelector('[data-device-products]');
  const status = root.querySelector('[data-device-status]');
  const pagination = root.querySelector('[data-device-pagination]');
  const more = root.querySelector('[data-device-more]');
  const submit = form.querySelector('[type=submit]');
  const strings = JSON.parse(root.querySelector('[data-device-strings]').textContent);
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency });
  const tags = JSON.parse(root.dataset.tags || 'null') || [];
  const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const textOnly = value => { const doc = new DOMParser().parseFromString(value || '', 'text/html'); return doc.body.textContent || ''; };
  const manufacturers = new Set();
  if (guidance) guidance.querySelectorAll('select option[value], .rd-category-links a').forEach(item => {
    if (/\/collections\//.test(item.value || item.getAttribute('href') || '')) {
      const value = item.textContent.trim();
      if (value && value.length < 70) manufacturers.add(value);
    }
  });
  const names = [...manufacturers].sort((a, b) => b.length - a.length);
  const normTags = tags.map(normalize);
  let catalog, loading, matches = [], limit = 24, timer;
  function prepare(product, index) {
    const productTags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(t => t.trim());
    if (!normTags.every(tag => productTags.some(t => normalize(t) === tag))) return null;
    const search = normalize([product.title, product.vendor, textOnly(product.body_html), ...productTags, ...(product.variants || []).map(v => v.sku)].join(' '));
    const supplied = productTags.find(tag => tag.startsWith('Equipment Manufacturer: '));
    const equipmentBrand = product.vendor;
    const prices = product.variants.map(v => Number(v.price)).filter(Number.isFinite);
    return { ...product, equipmentBrand, search, price: Math.min(...prices), priceVaries: new Set(prices).size > 1, index };
  }
  async function loadCatalog() {
    if (catalog) return catalog;
    if (loading) return loading;
    loading = (async () => {
      const all = [], seen = new Set();
      for (let page = 1; page <= 100; page++) {
        const response = await fetch(root.dataset.collectionUrl + '/products.json?limit=250&page=' + page, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
        if (!response.ok) throw new Error('Collection unavailable');
        const batch = (await response.json()).products;
        if (!Array.isArray(batch)) throw new Error('Invalid collection');
        for (const product of batch) {
          if (seen.has(product.id)) throw new Error('Repeated collection page');
          seen.add(product.id); all.push(product);
        }
        if (batch.length < 250) {
          catalog = all.map(prepare).filter(Boolean);
          const brands = [...new Set(catalog.map(p => p.equipmentBrand).filter(Boolean))].sort((a, b) => a.localeCompare(b));
          brands.forEach(value => brand.add(new Option(value, value)));
          brand.disabled = false;
          return catalog;
        }
      }
      throw new Error('Collection exceeds finder limit');
    })().catch(error => { loading = null; throw error; });
    return loading;
  }
  function element(tag, className, text) {
    const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node;
  }
  function draw() {
    const fragment = document.createDocumentFragment();
    matches.slice(0, limit).forEach(product => {
      const card = element('article', 'rd-lp-card');
      const url = '/products/' + encodeURIComponent(product.handle);
      const photo = element('a', 'rd-lp-image'); photo.href = url;
      const source = product.images?.[0]?.src;
      if (source && /^(https:)?\/\//.test(source)) { const img = element('img'); img.src = source; img.alt = product.title; img.loading = 'lazy'; img.width = 480; img.height = 480; photo.append(img); }
      const body = element('div', 'rd-lp-card-body');
      body.append(element('p', 'rd-lp-card-label', product.equipmentBrand || product.vendor));
      const heading = element('h3'), link = element('a', '', product.title); link.href = url; heading.append(link); body.append(heading);
      body.append(element('p', 'rd-lp-price', (product.priceVaries ? strings.from + ' ' : '') + money.format(product.price)));
      const detail = element('a', 'rd-lp-detail', strings.details + ' →'); detail.href = url; body.append(detail);
      card.append(photo, body); fragment.append(card);
    });
    if (!matches.length) fragment.append(element('p', 'rd-lp-empty', strings.empty));
    cards.replaceChildren(fragment); status.textContent = strings.results + ' (' + matches.length + ')';
    pagination.hidden = true; more.hidden = matches.length <= limit;
  }
  function apply(jump) {
    const words = query.value.trim().split(/\s+/).map(normalize).filter(Boolean);
    matches = catalog.filter(p => (!brand.value || p.equipmentBrand === brand.value) && words.every(word => p.search.includes(word) || (/^(cs|rd)/.test(word) && p.search.includes(word.replace(/^(cs|rd)/, word.startsWith('cs') ? 'rd' : 'cs')))));
    if (sort.value === 'price-low') matches.sort((a, b) => a.price - b.price);
    else if (sort.value === 'price-high') matches.sort((a, b) => b.price - a.price);
    else if (sort.value === 'name') matches.sort((a, b) => a.title.localeCompare(b.title));
    limit = 24; draw();
    if (jump) { status.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); status.focus({ preventScroll: true }); }
  }
  async function search(jump) {
    submit.disabled = true; form.setAttribute('aria-busy', 'true'); status.textContent = strings.loading;
    try { await loadCatalog(); apply(jump); }
    catch { status.textContent = strings.failure; }
    finally { submit.disabled = false; form.removeAttribute('aria-busy'); }
  }
  form.addEventListener('submit', event => { event.preventDefault(); search(true); });
  form.addEventListener('focusin', () => { if (!catalog && !loading) search(false); }, { once: true });
  query.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => { if (catalog) apply(false); }, 180); });
  brand.addEventListener('change', () => { if (catalog) apply(false); });
  sort.addEventListener('change', () => search(false));
  form.addEventListener('reset', () => { setTimeout(() => { if (catalog) apply(false); }, 0); });
  more.addEventListener('click', () => { limit += 24; draw(); });
})();

